import { makeAutoObservable, runInAction } from 'mobx';

import { Constants } from './DictionaryStore.types';

export class DictionaryStore {
  isReady = false;
  constants!: Constants;

  error?: Error;

  constructor() {
    makeAutoObservable(this);
  }

  initDictionaryStore = async () => {
    try {
      const response = await fetch(`${import.meta.env.MR_API_URI}/v2/constants/web`);
      const constants = await response.json();

      runInAction(() => {
        this.constants = constants;
      });
    } catch (e) {
      runInAction(() => {
        this.error = new Error((e as Error).message);
      });
    }

    runInAction(() => {
      this.isReady = true;
    });
  };

  getCutQualityById = (id?: Nullable<number>) => {
    return this.findItemInDictionaryById('cutQuality', id);
  };

  getCutQualityByShortLabel = (title: string) => {
    return this.findItemInDictionaryByShortLabel('cutQuality', title);
  };

  getClarityById = (id: number) => {
    return this.findItemInDictionaryById('clarity', id);
  };

  getColorById = (id?: Nullable<number>) => {
    return this.findItemInDictionaryById('color', id);
  };

  getPolishById = (id?: Nullable<number>) => {
    return this.findItemInDictionaryById('polish', id);
  };

  getSymmetryById = (id?: Nullable<number>) => {
    return this.findItemInDictionaryById('symmetry', id);
  };

  getFluorIntensityById = (id?: Nullable<number>) => {
    return this.findItemInDictionaryById('fluorIntensity', id);
  };

  getGirdleThicknessGradeById = (id?: Nullable<number>) => {
    return this.findItemInDictionaryById('girdleThicknessGrade', id);
  };

  private findItemInDictionaryById = (dictName: keyof Constants['dict'], id?: Nullable<number>) => {
    if (!this.constants.dict || !this.constants.dict[dictName]) {
      return null;
    }

    return this.constants.dict[dictName].find((i) => i.id === id);
  };

  private findItemInDictionaryByShortLabel = (dictName: keyof Constants['dict'], shortLabel: string) => {
    if (!this.constants.dict || !this.constants.dict[dictName]) {
      return null;
    }

    return this.constants.dict[dictName].find((i) => i.short === shortLabel);
  };
}

export type { Constants };
export const dictionaryStore = new DictionaryStore();
